import { type ReactElement, useEffect } from 'react';
import { useUserStore } from 'stores/user';

export const Metrics = (): ReactElement | null => {
  const user = useUserStore(state => state.user);
  const statisticsURL = user?.statisticsURL;

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return (): void => {
      document.body.style.overflow = '';
    };
  }, []);

  if (!statisticsURL) {
    return null;
  }

  return (
    <div className="fixed left-52 right-3 w-fit h-full border rounded-lg ">
      <iframe
        src={statisticsURL}
        className="w-full h-full rounded-lg border-none block overflow-auto"
        title="Estadísticas"
      />
    </div>
  );
};
